import React from "react";

function Footer() {
  return (
    <footer>
      <div class="about_info">
        <p>© 2026 Zakaria Hizzi . All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
